import { render } from "./MenuDown.vue?vue&type=template&id=6f3de39d"
import script from "./MenuDown.vue?vue&type=script&lang=js"
export * from "./MenuDown.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/MenuDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f3de39d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f3de39d', __exports__)) {
    api.reload('6f3de39d', __exports__)
  }
  
  module.hot.accept("./MenuDown.vue?vue&type=template&id=6f3de39d", () => {
    api.rerender('6f3de39d', render)
  })

}


export default __exports__